import { Routes, Route } from 'react-router-dom';
import Home from './Pages/Home';
import Live from './Pages/Live';

const Main = () => {
return (         
    <Routes>
    <Route path='/:stream' element={<Home/>} />
    <Route path='/live/:stream' element={<Live/>} />
  </Routes>
);
}
export default Main;